import { useGetInterventionTemplate } from "@/entities/intervention-template";

import { useSectionUriParams } from "./InterventionTemplateSection.hook";

export const useGetInterventionTemplateSection = (interventionTemplateId) => {
  const { layout_index } = useSectionUriParams();

  const { template, ...queryResult } = useGetInterventionTemplate(
    interventionTemplateId,
    {
      params: { layout_index },
      neverStale: true,
    }
  );

  return {
    section: template,
    ...queryResult,
  };
};
